import {
    DSTable,
    DSTableBodyLoadable,
    DSTableCell,
    DSTableContainer,
    DSTableHead,
    DSTableRow,
    DSTypography,
    Translate,
} from '@deltasierra/components';
import React from 'react';
import { BlockedTemplateContentBuildEmailPreviewFragment } from './__graphqlTypes/BlockedTemplateContentBuildEmailPreviewFragment';
import { BlockedPreviewsTableRow, BlockedPreviewsTableRowProps } from './BlockedPreviewsTableRow';

type BlockedPreviewsTableProps = Pick<BlockedPreviewsTableRowProps, 'disableActions' | 'onApprove'> & {
    loading: boolean;
    rows: BlockedTemplateContentBuildEmailPreviewFragment[];
};

export function BlockedPreviewsTable({
    disableActions,
    loading,
    onApprove,
    rows,
}: BlockedPreviewsTableProps): JSX.Element {
    return (
        <DSTableContainer>
            <DSTable size="medium">
                <DSTableHead>
                    <DSTableRow>
                        <DSTableCell>{'Created At'}</DSTableCell>
                        <DSTableCell>
                            <DSTypography variant="subtitle1">
                                <Translate keyId="COMMON.CLIENT" />
                            </DSTypography>
                            <Translate keyId="COMMON.LOCATION" />
                        </DSTableCell>
                        <DSTableCell>{'Content'}</DSTableCell>
                        <DSTableCell>{'Details'}</DSTableCell>
                        <DSTableCell>
                            <Translate keyId="COMMON.ACTIONS" />
                        </DSTableCell>
                    </DSTableRow>
                </DSTableHead>
                <DSTableBodyLoadable disableInteraction={false} loading={loading}>
                    {rows.length > 0 ? (
                        rows.map(row => (
                            <BlockedPreviewsTableRow
                                disableActions={disableActions}
                                key={row.id}
                                row={row}
                                onApprove={onApprove}
                            />
                        ))
                    ) : (
                        <DSTableRow>
                            <DSTableCell align="center" colSpan={9}>
                                {'No blocked previews found.'}
                            </DSTableCell>
                        </DSTableRow>
                    )}
                </DSTableBodyLoadable>
            </DSTable>
        </DSTableContainer>
    );
}
BlockedPreviewsTable.displayName = 'BlockedPreviewsTable';
